import '../../common/base';
import Vue from '../../common/vue-common';
import PartnershipTerms from '../../components/partnership/PartnershipTerms';
import PainelTerms from '../../components/partnership/terms/PainelTerms';
import PhotoTerms from '../../components/partnership/terms/PhotoTerms';
import ArtTerms from '../../components/partnership/terms/ArtTerms';
import ProductTerms from '../../components/partnership/terms/ProductTerms';
import MktTerms from '../../components/partnership/terms/MktTerms';
import PriceTerms from '../../components/partnership/terms/PriceTerms';
import CarrierTerms from '../../components/partnership/terms/CarrierTerms';
import PartnerExchangeTerms from '../../components/partnership/terms/PartnerExchangeTerms';
import ContactTerms from '../../components/partnership/terms/ContactTerms';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        name: 'painel',
        path: '/painel',
        component: PainelTerms,
    },
    {
        name: 'fotos',
        path: '/fotos',
        component: PhotoTerms,
    },
    {
        name: 'estampas',
        path: '/estampas',
        component: ArtTerms,
    },
    {
        name: 'produtos',
        path: '/produtos',
        component: ProductTerms,
    },
    {
        name: 'divulgacao',
        path: '/divulgacao',
        component: MktTerms,
    },
    {
        name: 'precos',
        path: '/precos',
        component: PriceTerms,
    },
    {
        name: 'fretes',
        path: '/fretes',
        component: CarrierTerms,
    },
    {
        name: 'trocas',
        path: '/trocas',
        component: PartnerExchangeTerms,
    },
    {
        name: 'atendimento',
        path: '/atendimento',
        component: ContactTerms,
    },
];

const router = new VueRouter({
    base: '/termos-condicoes',

    mode: 'history',

    routes,

    scrollBehavior(to, from, savedPosition) {
        if (to.name) {
            return {
                selector: '#main',
            };
        }
    },
});

new Vue({
    router,
    render: (h) => h(PartnershipTerms),
}).$mount('#VueTerms');
